import { useTranslation } from 'react-i18next';
import { z } from 'zod';

// ===== Zod schema for a single ScenarioItem =====

export const getBenchmarkingItemSchema = (t: ReturnType<typeof useTranslation>['t']) =>
    z.object({
      customerId: z.string().min(1, t('onboarding.fields.errors.selectOrigin', 'Select origin')),
      vendorId: z.string().min(1, t('onboarding.fields.errors.selectDestination', 'Select destination')),
      localCurrency: z.string().min(1, 'Currency is required').trim().toUpperCase(),
      invoicingConcept: z.enum(['infrastructure', 'licenses', 'service', 'support'], {
        message: t('onboarding.fields.errors.invoicingConcept', 'Select a concept'),
      }),
    }).superRefine((data, ctx) => {
      if (data.customerId && data.vendorId && data.customerId === data.vendorId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['vendorId'],
          message: t('onboarding.fields.errors.differentOriginDestination', 'Origin and destination must be different'),
        });
      }
    }); 

  export type BenchmarkingFormValues = z.infer<ReturnType<typeof getBenchmarkingItemSchema>>;